<template>
  <div class="app-container">
    <el-card class="weather-search" shadow="never">
      <template #header>
        <el-form inline size="mini">
          <el-form-item :label="$t('text.kssj')">
            <el-date-picker
              :key="queryStartTimeKey"
              v-model="queryParams.starttime"
              :placeholder="$t('placeholder.kssj')"
              :type="queryParams.queryType"
            />
          </el-form-item>
          <el-form-item :label="$t('text.jssj')">
            <el-date-picker
              :key="queryEndTimeKey"
              v-model="queryParams.endtime"
              :placeholder="$t('placeholder.jssj')"
              :type="queryParams.queryType"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" :loading="queryLoading" @click="getHistoryData">{{ $t("button.cx") }}</el-button>
            <el-button type="primary" :loading="queryLoading" icon="el-icon-download" @click="exportReport">{{ $t("button.dc") }}</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template #default>
        <el-table
          v-loading="queryLoading"
          height="100%"
          :data="tablist"
          element-loading-spinner="el-icon-loading"
          element-loading-background="rgba(0, 0, 0, 0.8)"
        >
          <el-table-column
            :label="$t('text.rq')"
            prop="sitetime"
            align="center"
            width="160px"
            :formatter="sitetimeFormat"
          />
          <el-table-column :label="$t('text.wendu')" prop="temperature" align="center" />
          <el-table-column :label="$t('text.tpwd')" prop="pathtemper" align="center" />
          <el-table-column :label="$t('text.fsds')" prop="humidity" align="center" />
          <el-table-column :label="$t('text.rain')" prop="rain" align="center" />
          <el-table-column :label="$t('text.fqy')" prop="airpressure" align="center" />
          <el-table-column :label="$t('text.rainstrength')" prop="rainstrength" align="center" />
          <el-table-column :label="$t('text.ffs')" prop="sunshine" align="center" />
          <el-table-column :label="$t('text.ffx')" prop="winddirection" align="center" />
          <el-table-column :label="$t('text.ffengs')" prop="windspeed" align="center" />
        </el-table>
      </template>
    </el-card>
  </div>
</template>
<script>
import {
  GetWeatherHistorys,
  QueryWeathereReals,
  ExpWeatherHistorys,
} from "@/api/Weather"
export default {
  name: "WeatherSearch",
  components: {},
  data () {
    return {
      queryLoading: false,
      tablist: [],
      queryParams: {
        /** 开始时间 */
        starttime: new Date(),
        /** 结束时间 */
        endtime: new Date(),
        /** 采集器主键 */
        gatewayId: "",
        /** 查询类型 1:天 2：月 */
        queryType: 'date'
      },
      queryTimeFormat: {
        date: {
          startTime: 'yyyy-MM-dd 00:00:00',
          endTime: 'yyyy-MM-dd 23:59:59'
        },
        month: {
          startTime: 'yyyy-MM-01 00:00:00',
          endTime: 'yyyy-MM-01 00:00:00'
        }
      },
      queryStartTimeKey: Math.random(),
      queryEndTimeKey: Math.random()
    }
  },
  mounted () {
    this.queryDeviceList().then(() => {
      this.getHistoryData()
    })
  },
  methods: {
    /** 数据上传时间格式化 */
    sitetimeFormat (row, column, cellValue, index) {
      return this.$parseTime(cellValue, "yyyy-MM-dd hh:mm:ss")
    },

    /** 获取设备列表 */
    queryDeviceList () {
      this.queryLoading = true
      return new Promise((resolve, reject) => {
        QueryWeathereReals({
          page: 1,
          perPage: 10,
          orderBy: "",
          whereCondition: JSON.stringify({ orgid: this.$store.getters.station.id }),
        }).then(({ data }) => {
          if (data.queryResults && data.queryResults.length > 0) {
            this.queryParams.gatewayId = data.queryResults[0].gatewayid
            resolve()
          } else {
            this.$messgae({ message: '此电站不存在气象设备', type: 'error' })
            reject()
          }
        }).catch(() => {
          this.queryLoading = false
          this.$messgae({ message: '查询设备列表失败', type: 'error' })
          reject()
        })
      })
    },

    /** 获取设备历史数据 */
    getHistoryData () {
      this.queryLoading = true
      const tiemFormat = this.queryTimeFormat[this.queryParams.queryType]
      GetWeatherHistorys({
        gatewayId: this.queryParams.gatewayId,
        startTime: this.$parseTime(this.queryParams.starttime, tiemFormat.startTime),
        endTime: this.$parseTime(this.queryParams.endtime, tiemFormat.endTime),
        dateType: this.queryParams.queryType
      }).then(({ data }) => {
        this.tablist = data || []
      }).then(() => {
        this.queryLoading = false
      }).catch(() => {
        this.queryLoading = false
        this.$messgae({ message: '查询设备历史数据失败', type: 'error' })
      })
    },

    tableRowClass ({ row, rowIndex }) {
      return rowIndex % 2 === 0 ? 'even-row' : 'odd-row'
    },

    /** 导出设备历史数据 */
    exportReport () {
      if (!this.queryParams.gatewayId) return
      this.queryLoading = true
      const tiemFormat = this.queryTimeFormat[this.queryParams.queryType]
      ExpWeatherHistorys({
        gatewayId: this.queryParams.gatewayId,
        startTime: this.$parseTime(this.queryParams.starttime, tiemFormat.startTime),
        endTime: this.$parseTime(this.queryParams.endtime, tiemFormat.endTime),
        dateType: this.queryParams.queryType
      }).then(({ data }) => {
        window.location.href = data
      }).then(() => {
        this.queryLoading = false
      }).catch(() => {
        this.queryLoading = false
        this.$messgae({ message: '导出设备历史数据失败', type: 'error' })
      })
    },
  },
}
</script>
<style scoped>
.weather-search{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  background-color: var(--card-bg-color);
  border-color: var(--card-bg-color);
}

.weather-search>>> .el-card__header {
  width: 100%;
  height: 50px;
  padding: 0 20px;
  box-sizing: border-box;
  border-bottom: none;
}
.weather-search>>> .el-card__header .el-form{
  width: 100%;
  height: 100%;
  padding: 0;
  box-sizing: border-box;
  display: flex;
  align-items: center;
}
.weather-search>>> .el-card__header .el-form .el-form-item{
  margin-bottom: 0;
}

.weather-search>>> .el-card__body {
  width: 100%;
  height: calc(100% - 50px);
  padding: 0 20px;
  box-sizing: border-box;
}
</style>
